<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M20.3125 14.8438V12.1094C20.3125 10.1677 18.7385 8.59375 16.7969 8.59375H15.2344C14.5872 8.59375 14.0625 8.06908 14.0625 7.42188V5.85938C14.0625 3.91775 12.4885 2.34375 10.5469 2.34375H8.59375M8.59375 15.625H16.4062M8.59375 18.75H12.5M10.9375 2.34375H5.85938C5.21217 2.34375 4.6875 2.86842 4.6875 3.51562V21.4844C4.6875 22.1316 5.21217 22.6562 5.85937 22.6562H19.1406C19.7878 22.6562 20.3125 22.1316 20.3125 21.4844V11.7188C20.3125 6.54108 16.1152 2.34375 10.9375 2.34375Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgDocument',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
